'use strict';

exports.__esModule = true;
exports.renderRoutes = exports.matchRoutes = undefined;

var _matchRoutes2 = require('./matchRoutes');

var _matchRoutes3 = _interopRequireDefault(_matchRoutes2);

var _renderRoutes2 = require('./renderRoutes');

var _renderRoutes3 = _interopRequireDefault(_renderRoutes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.matchRoutes = _matchRoutes3.default;
exports.renderRoutes = _renderRoutes3.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-router-config/index.js
// module id = 140
// module chunks = 0